var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticClass:"btn-close login-dailog",attrs:{"title":_vm.title,"append-modelody":true,"modal-append-to-body":false,"width":"470px","top":"50px","visible":_vm.dialogVisible},on:{"close":_vm.onCancel}},[_c('loginControl',{ref:"loginRef",attrs:{"initOpen":_vm.dialogVisible,"toTab":_vm.toTab},on:{"close":_vm.onCancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/components/dialog/login-dialog.vue?vue&type=template&id=d101fa8a
// module id = null
// module chunks = 